<template>
  <PlayerSpotlight
    playerName="ERNIE BANKS"
    :playerImages="[
      require('@/assets/images/galleries/ERNIE/ERNIE-SLIDER-01.jpg'),
      require('@/assets/images/galleries/ERNIE/ERNIE-SLIDER-02.jpg'),
      require('@/assets/images/galleries/ERNIE/ERNIE-SLIDER-03.jpg'),
      require('@/assets/images/galleries/ERNIE/ERNIE-SLIDER-04.jpg'),
      require('@/assets/images/galleries/ERNIE/ERNIE-SLIDER-05.jpg'),
    ]"
    playerQuote="“There’s sunshine, fresh air, and the team’s behind us. Let’s play two.”"
  >
    <div slot="primaryParagraph">
      <p>
        Ernie Banks played the game he loved as a lifelong Cub for 19 seasons
        from when he made his debut with the club in 1953 until his retirement
        in 1971. He was a 14-time All-Star, back-to-back National League Most
        Valuable Player in 1958 and 1959, and was inducted into the National
        Baseball Hall of Fame in 1977.
      </p>
      <p>
        Starting while still a player in 1967, Banks turned his eye to coaching
        and served in that role through 1973. He became the
        first player in franchise history to have his number retired in 1982 and
        was voted to Major League Baseball’s All-Century Team in 1999. In 2013,
        Banks was presented with the Presidential Medal of Freedom.
      </p>
      <p>
        Beyond his statistics on the field, Banks is remembered for his
        endearing charm and his remarkable wit. He became the first player in
        franchise history to be honored with a statue at Wrigley Field when he
        helped with the unveiling at Clark and Addison on March 31, 2008. His
        statue is adorned with his famous line, “Let’s Play Two.”
      </p>
    </div>
  </PlayerSpotlight>
</template>

<script>
import PlayerSpotlight from "@/components/global/PlayerSpotlight";
export default {
  name: "BuckONeil",
  components: {
    PlayerSpotlight,
  },
};
</script>
